export default function ({ context }) {
  const devUrl = 'https://gb.dev.gb.ru/api/advcake/v1'
  const prodUrl = 'https://gb.ru/api/advcake/v1'

  const baseUrl = context.$config.isProd ? prodUrl : devUrl
  let currentPage = 1

  return {
    async getStatus() {
      try {
        const { registered } = await context.$axios.get(`${baseUrl}/registered`, {
          useCache: false
        })

        return registered
      } catch (e) {
        console.warn(e)
      }
    },

    async getLinks() {
      try {
        const { links } = await context.$axios.get(`${baseUrl}/links`, {
          useCache: false
        })

        const [{ link }] = links

        return link
      } catch (e) {
        console.warn(e)

        return null
      }
    },

    async getFinanceStats() {
      try {
        const { finance } = await context.$axios.get(
          `${baseUrl}/finance`,
          {
            useCache: false
          }
        )

        return finance
      } catch (e) {
        console.warn(e)

        return {}
      }
    },

    async getGeneralStats() {
      try {
        const { statGeneral } = await context.$axios.get(
          `${baseUrl}/stat-general`,
          {
            useCache: false
          }
        )

        return statGeneral
      } catch (e) {
        console.warn(e)

        return {}
      }
    },

    async getDetailStats(nextPage = false) {
      try {
        const { statDetails, links } = await context.$axios.get(`${baseUrl}/stat-details`, {
            useCache: false,
            params: {
              'page[size]': 5,
              'page[number]': nextPage ? ++currentPage : 1
            }
          })

        const isMore = !!links?.next

        return { details: statDetails, isMore }
      } catch (e) {
        console.warn(e)

        return { details: [], isMore: false }
      }
    },

    async register() {
      try {
        const status = await context.$axios.post(
          `${baseUrl}/register`,
          null
        )

        return {
          registered: status?.registered,
          message: status?.message
        }
      } catch (e) {
        console.warn(e)
      }
    },
  }
}
